import { keyframes } from '@emotion/react';

export const pulseAnimation = keyframes`
0% {
  transform: scale(1);
}

55% {
  transform: scale(1.6);
}
`;

export const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
